export enum EnumLocalLang {
	FR = "fr",
	EN = "en",
}
